"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Tooltip.scss");
var TooltipProps_1 = require("./TooltipProps");
var key_press_1 = require("../../../utils/key-press");
var Join_1 = require("../../../helpers/Functions/Join");
var Tooltip = function (_a) {
    var infoTxt = _a.infoTxt, boxWidth = _a.boxWidth, _b = _a.position, position = _b === void 0 ? "top" : _b, children = _a.children, style = _a.style, className = _a.className, offset = _a.offset, _c = _a.show, show = _c === void 0 ? false : _c, _d = _a.content, content = _d === void 0 ? "stuff" : _d, testId = _a.testId, zIndex = _a.zIndex, ariaId = _a.ariaId, _e = _a.type, type = _e === void 0 ? "dark" : _e;
    var _f = __read(React.useState(show), 2), showState = _f[0], setShowState = _f[1];
    var _g = __read(React.useState(position), 2), positionState = _g[0], setPositionState = _g[1];
    var _h = __read(React.useState(false), 2), isClick = _h[0], setIsClick = _h[1];
    var _j = __read(React.useState(false), 2), isHover = _j[0], setIsHover = _j[1];
    var _k = __read(React.useState(true), 2), isFocusable = _k[0], setIsFocusable = _k[1];
    var arrowRef = React.useRef(null);
    var boxRef = React.useRef(null);
    var triggerRef = React.useRef(null);
    var noWrap = false;
    React.useEffect(function () {
        if (process.browser && window) {
            suppressFocus();
            checkPosition();
            window.addEventListener("resize", checkPosition);
        }
        return function () {
            if (process.browser && window) {
                suppressFocus();
                window.removeEventListener("resize", checkPosition);
            }
        };
    }, []);
    var checkPosition = React.useCallback(function () {
        if (process.browser && window) {
            // if width of box exceeds screen size, set it responsively to the size of the screen
            if (!boxRef.current || !arrowRef.current || !triggerRef.current) {
                return;
            }
            var currentBox = boxRef.current;
            var bounds = currentBox.getBoundingClientRect();
            var currentArrow = arrowRef.current;
            var arrowBounds = currentArrow.getBoundingClientRect();
            var currentTrigger = triggerRef.current;
            var triggerBounds = currentTrigger.getBoundingClientRect();
            // if it is the size of the screen
            var sidePadding = window.innerWidth > 600 ? 32 : 16;
            // vertical positioning
            if (position === "top" && bounds.top < sidePadding) {
                setPositionState("bottom");
            }
            else if (position === "bottom" && bounds.bottom > window.innerHeight - sidePadding) {
                setPositionState("top");
            }
            if (bounds.width >= document.documentElement.clientWidth - sidePadding * 2) {
                currentBox.style.width =
                    document.documentElement.clientWidth - (sidePadding + 10) * 2 + "px";
            }
            else {
                currentBox.style.width = bounds.width + "px";
            }
            if (bounds.left < sidePadding) {
                currentBox.style.left =
                    sidePadding +
                        Math.abs(arrowBounds.left +
                            8 -
                            parseInt(currentBox.style.width.slice(0, -2), 10) / 2) +
                        triggerBounds.width / 2 +
                        "px";
                if (currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width >=
                    document.documentElement.clientWidth - sidePadding) {
                    var tmpLeft = parseInt(currentBox.style.left.slice(0, -2), 10);
                    currentBox.style.left =
                        tmpLeft -
                            (currentBox.getBoundingClientRect().right -
                                (document.documentElement.clientWidth - sidePadding)) +
                            "px";
                }
            }
            if (bounds.right > document.documentElement.clientWidth - sidePadding) {
                var extra = arrowBounds.left +
                    6 +
                    parseInt(currentBox.style.width.slice(0, -2), 10) / 2 -
                    (document.documentElement.clientWidth - sidePadding);
                currentBox.style.left = -extra + "px";
                if (currentBox.getBoundingClientRect().left < sidePadding) {
                    var tmpLeft = parseInt(currentBox.style.left.slice(0, -2), 10);
                    currentBox.style.left =
                        tmpLeft + (sidePadding - currentBox.getBoundingClientRect().left) + "px";
                }
            }
            if (
            // is there an offset? Is that offset less than half the width of the box? If I relocate it, will the offset push me off the page?
            offset &&
                Math.abs(offset) < currentBox.getBoundingClientRect().width / 2 - 15 &&
                currentBox.getBoundingClientRect().left + offset > sidePadding &&
                currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width +
                    offset <
                    window.innerWidth - sidePadding) {
                currentBox.style.left = "calc(50% + " + offset + "px)";
                // make sure its not pushhing off screen
                if (currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width >=
                    window.innerWidth - sidePadding) {
                    var extra = arrowBounds.left +
                        6 +
                        parseInt(currentBox.style.width.slice(0, -2), 10) / 2 -
                        (document.documentElement.clientWidth - sidePadding);
                    currentBox.style.left = -extra + "px";
                }
                else if (currentBox.getBoundingClientRect().left < sidePadding) {
                    currentBox.style.left =
                        sidePadding +
                            Math.abs(arrowBounds.left +
                                6 -
                                parseInt(currentBox.style.width.slice(0, -2), 10) / 2) +
                            triggerBounds.width / 2 +
                            "px";
                }
            }
        }
    }, []);
    function suppressFocus() {
        if (triggerRef.current) {
            var items = triggerRef.current.querySelectorAll("input, button, a, select, textarea");
            if (items.length > 0) {
                setIsFocusable(false);
            }
            else {
                setIsFocusable(true);
            }
        }
        else {
            setIsFocusable(true);
        }
    }
    var tooltipLabel = "tooltip";
    var tooltipId = getId();
    var msgid = "msg-" + (ariaId ? ariaId : tooltipId);
    if (!boxWidth &&
        boxRef &&
        boxRef.current &&
        boxRef.current.getBoundingClientRect().width < 320) {
        noWrap = true;
    }
    function getId() {
        if (typeof document !== "undefined") {
            var temp = tooltipLabel
                .replace(/ /g, "-")
                .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
                .toLowerCase();
            while (document.getElementById(temp)) {
                temp = temp.concat(Math.floor(Math.random() * 100 + 1).toString());
            }
            return temp;
        }
        else {
            return tooltipLabel;
        }
    }
    var KeyDownHandler = function (e) {
        if (key_press_1.KeyPress.escIsPressed(e)) {
            hideTooltip();
            setIsClick(false);
            setIsHover(false);
        }
        else {
            if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
                e.preventDefault();
                if (!showState) {
                    showTooltip();
                    setIsClick(true);
                    setIsHover(false);
                }
                else {
                    hideTooltip();
                    setIsClick(false);
                    setIsHover(false);
                }
            }
        }
    };
    return (React.createElement("div", { className: "inline-block", style: { verticalAlign: "middle" }, "data-testid": testId },
        React.createElement("div", { className: Join_1.join(["outerContainer", className]), style: style, "data-testid": testId, id: ariaId ? ariaId : tooltipId },
            positionState === "top" && positionTop(),
            React.createElement("span", { className: "hidden-spoken", id: msgid }, content),
            React.createElement("div", { tabIndex: isFocusable ? 0 : -1, ref: triggerRef, className: Join_1.join("rel", "trigger", styles.childContainer), onClick: onClick, onMouseEnter: onHoverIn, onMouseLeave: onHoverOut, onBlur: onBlur, onKeyDown: KeyDownHandler, role: "button", "aria-describedby": msgid, "aria-label": infoTxt ? infoTxt : "Help", "aria-expanded": showState ? true : false }, children),
            positionState === "bottom" && positionBottom())));
    function positionTop() {
        return (React.createElement("div", { className: zIndex === undefined || zIndex === false ? "rel" : styles.relPmt },
            React.createElement("div", { ref: boxRef, style: { width: boxWidth }, className: Join_1.join("infoBox", showState && styles.show, styles.infoBox, type === "light" ? styles.bgwhite : "", TooltipProps_1.PositionType[positionState], noWrap ? "nowrap" : "") },
                React.createElement("div", { className: Join_1.join("mar-b-none infoText pad-t-xxs pad-b-xxs pad-l-xs pad-r-xs line-h-md", styles.textInfo, type === "light" ? styles.bgwhite : "") }, content)),
            React.createElement("div", { ref: arrowRef, className: Join_1.join("arrow", showState && styles.show, styles.arrow, type === "light" ? styles.bgwhite : "", TooltipProps_1.PositionType[positionState]) })));
    }
    function positionBottom() {
        return (React.createElement("div", { className: zIndex === undefined || zIndex === false ? "rel" : styles.relPmt },
            React.createElement("div", { ref: arrowRef, className: Join_1.join("arrow", showState && styles.show, styles.arrow, type === "light" ? styles.bgwhite : "", TooltipProps_1.PositionType[positionState]) }),
            React.createElement("div", { ref: boxRef, style: { width: boxWidth }, className: Join_1.join("infoBox", showState && styles.show, styles.infoBox, type === "light" ? styles.bgwhite : "", TooltipProps_1.PositionType[positionState], noWrap ? "nowrap" : "") },
                React.createElement("div", { className: Join_1.join("mar-b-none infoText pad-t-xxs pad-b-xxs pad-l-xs pad-r-xs line-h-md", styles.textInfo, type === "light" ? styles.bgwhite : "") }, content))));
    }
    function onHoverOut() {
        if (isClick) {
            return;
        }
        else {
            hideTooltip();
            setIsHover(false);
        }
    }
    function onHoverIn() {
        setIsHover(true);
        showTooltip();
    }
    function onBlur() {
        setIsClick(false);
        setIsHover(false);
        hideTooltip();
    }
    function onClick(e) {
        e.stopPropagation();
        if (isHover) {
            showTooltip();
            setIsClick(true);
            setIsHover(false);
        }
        else if (showState) {
            hideTooltip();
            setIsClick(false);
        }
        else {
            showTooltip();
            setIsClick(true);
            setIsHover(false);
        }
    }
    function showTooltip() {
        checkPosition();
        setShowState(true);
    }
    function hideTooltip() {
        setShowState(false);
        setPositionState(position);
    }
};
exports.default = Tooltip;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tooltip/Tooltip.js
// module id = 1662
// module chunks = 8